import { render, staticRenderFns } from "./appSidebar.vue?vue&type=template&id=36d5d9f8&scoped=true"
import script from "./appSidebar.vue?vue&type=script&lang=js"
export * from "./appSidebar.vue?vue&type=script&lang=js"
import style0 from "./appSidebar.vue?vue&type=style&index=0&id=36d5d9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5d9f8",
  null
  
)

export default component.exports